module.exports = __webpack_public_path__ + "static/media/nike-like-a-lioness-lauren.d7c4bbc5.gif";